/** The ticket page's composer from its address. `?compose=reply` writes to the customer; anything else opens no composer. The composer-and-fixes
 *  round (2026-11-03; brief rule 6): the discussion mode is gone, so `?compose=discussion` opens the Discussion tab's box instead (the page
 *  translates it into the tab's address and clears `compose`); the retired `?compose=note` opens nothing; `?compose=prompt` is the AI's ask. */
export type TicketComposerMode = "reply";

export const composerModeOf = (compose: string | null): TicketComposerMode | null => (compose === "reply" ? compose : null);

/** the same test on the address as it is right now, for a key that can beat the re-render */
export const composingNow = (search: string): boolean => /(^|[?&])compose=reply(&|$)/.test(search);
